module.exports = __webpack_public_path__ + "static/media/ShowsImage3.d486b4a4.jpg";